import { getLocalApi } from "./localApi";

export type CentreDetailsDto = {
  centreId: number;
  name: string;
  countryCode: string;
  currencyCode: string;
  centreCode: string;
  isActive: boolean;
  physicalCentre: boolean;
  printFormat: number;
  generalEmail?: string;
  accommodationEmail?: string;
  telephone?: string;
  emergencyTelephone?: string;
  schoolSponsorshipNumber?: string;
  vatNumber?: string;
  registrationNumber?: string;
  vatExemptionNumber?: string;
  chequePayableTo?: string;
  address?: {
    id: number;
    line1?: string; line2?: string; line3?: string; line4?: string;
    countryISOCode?: string;
  };
  logo?: {
    image?: string;
    contentType?: string;
    fileName?: string;
  };
  contacts?: Array<{
    id: number;
    contactType: number;
    name?: string;
    email?: string;
    signatureImage?: string;
    signatureContentType?: string;
    signatureFileName?: string;
  }>;
  bankDetails?: {
    id: number;
    beneficiaryName?: string;
    accountNumber?: string;
    bankName?: string;
    iban?: string;
    swiftCode?: string;
    branchCode?: string;
    abaRoutingNo?: string;
    achAba?: string;
    intermediaryBankName?: string;
    intermediarySwiftCode?: string;
    bankAddress?: {
      id: number; line1?: string; line2?: string; line3?: string; line4?: string; countryISOCode?: string;
    };
    beneficiaryBankAddress?: {
      id: number; line1?: string; line2?: string; line3?: string; line4?: string; countryISOCode?: string;
    };
    intermediaryBankAddress?: {
      id: number; line1?: string; line2?: string; line3?: string; line4?: string; countryISOCode?: string;
    };
  };
  createdOn?: string;
  createdBy?: string;
  lastModifiedOn?: string;
  lastModifiedBy?: string;
};


export async function getCentreById(centreId: number): Promise<CentreDetailsDto> {
  const api = await getLocalApi();
  const res = await api.call(`Centres/${encodeURIComponent(String(centreId))}`, "GET", null);
  if (!res?.ok) throw new Error("Failed to fetch centre by id");
  return await res.json();
}